// extracted by mini-css-extract-plugin
export var actionIcon = "_ux-0";